// @flow

var JitsiMeetJS = window.JitsiMeetJS;

export default JitsiMeetJS;
